import { MIN_REFRESH_TIME } from '../requestCache';

let logAPIuse = false;
let loginfoTimes = {};
let extensiveLogging = false;

if (process.env.NODE_ENV === 'development') {
  logAPIuse = true;
}

export const loginfo = (key = null) => {
  if (logAPIuse) {
    // Create a new error stack
    const errorStack = new Error().stack;

    // Split the stack to find the route name
    const stackLines = errorStack.split('\n');
    const routeName = stackLines
      .filter((line) => line.includes('at'))[1]
      .trim()
      .split('.')[1]
      .split(' ')[0];

    if (loginfoTimes[routeName]) {
      if (Date.now() - loginfoTimes[key || routeName].timestamp < MIN_REFRESH_TIME) {
        if (extensiveLogging) {
          console.warn(
            key || routeName,
            'hit too recently!',
            loginfoTimes[key || routeName].count,
            'times total - Make sure to use tryCache for GET requests.',
            'Last hit was',
            (Date.now() - loginfoTimes[key || routeName].timestamp) / 1000,
            'second(s) ago.',
          );
        }
      } else {
        if (extensiveLogging) console.log(key || routeName, 'hit okay!');
      }
    }
    loginfoTimes[key || routeName] = {
      timestamp: Date.now(),
      count: loginfoTimes[key || routeName] ? loginfoTimes[key || routeName].count + 1 : 1,
    };
  }
};

export default { loginfo };
